import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SharedStore } from '@shared/store/shared.signal-store';

export const houseLpResolver: ResolveFn<void> = () => {
  const sharedStore = inject(SharedStore);

  sharedStore.loadLiquidityProviders();
  sharedStore.loadAccounts();
  sharedStore.loadPairs();
};
